import './CopyA.scss';

import { b2x } from '@b2x/react/src';
import classnames from 'classnames';
import React from 'react';

import { ComponentWrapper } from './ComponentWrapper';
import { ProductListAContentType } from './contentTypes';

export const ProductListA = ({ header, options, productsIds }: ProductListAContentType) => {
  const _headingType = header?.headingType as string;
  const currentBreakpoint = b2x.useBreakpoint();

  return (
    <ComponentWrapper classNames="product-list-a" options={options}>
      {(header?.title || header?.preTitle) && (
        <b2x.Div
          className="mb-lg-5 mb-4"
          display={'flex'}
          flexDirection={'column'}
          gap={{ md: 4, xs: 3 }}
          textAlign={'center'}
        >
          {header.preTitle && (
            <p
              className={classnames(
                'mb-0',
                { h4: b2x.untilBreakpoint('sm', currentBreakpoint) },
                { h3: !b2x.untilBreakpoint('sm', currentBreakpoint) }
              )}
            >
              {header.preTitle}
            </p>
          )}
          <b2x.Div display={'flex'} justifyContent={'center'}>
            <b2x.Div
              alignItems={'center'}
              display={'flex'}
              flexWrap={'wrap'}
              gap={{ md: 3, xs: 2 }}
              justifyContent={'center'}
            >
              {header.logo?.type && <b2x.AssetV2 className="d-block" {...header.logo} fluid />}
              {React.createElement(_headingType, { class: 'h1 m-0 lh-1' }, header.title?.toUpperCase())}
            </b2x.Div>
          </b2x.Div>
        </b2x.Div>
      )}
      {productsIds && (
        <b2x.ProductsByIds ids={productsIds.map(({ id }) => id)}>
          {(products) => (
            <b2x.EqualHeight>
              <b2x.Listing name="Product list - A" products={products}>
                <b2x.Row>
                  {products?.map((product) => (
                    <b2x.Col key={product.id} size={{ md: 6, xs: 12 }}>
                      <b2x.ProductTile product={product} />
                    </b2x.Col>
                  ))}
                </b2x.Row>
              </b2x.Listing>
            </b2x.EqualHeight>
          )}
        </b2x.ProductsByIds>
      )}
    </ComponentWrapper>
  );
};
